/**
 * Brand identity — the single home for every customer-visible brand string
 * (BOLT-404 rebrand: 97 Display → LeadCraft).
 *
 * Every surface a paying customer sees imports from here: portal chrome,
 * email sender names and template copy, notification bodies, the SMS consent
 * page. The next rename is this file plus the two static surfaces in this repo
 * that cannot import TS (apps/portal/index.html,
 * apps/api/public/embed/lead-form.js — both carry a comment pointing back
 * here), plus Beam's src/scripts/waf-token.ts, whose literal deliberately
 * still reads "97 Display security check": the user declined that retitle
 * (2026-09-09). See FLOW-017.
 *
 * NOT brand strings, never sourced from here: domains and email addresses
 * (97display.net/.com), JWT issuer/audience, Secrets Manager paths, Maxio
 * site keys and the portal labels that name real legacy Maxio billing sites.
 */
export const BRAND = {
    /** Product name on every portal / email / notification surface. */
    productName: 'LeadCraft',
    /**
     * The login wordmark's two halves, rendered in two tones ("Lead" in the text
     * colour, "Craft" in brand blue). They live here so a rename cannot leave a
     * hardcoded wordmark behind on the most-seen screen in the product;
     * `brand.test.ts` asserts they still spell `productName`.
     */
    productNameParts: ['Lead', 'Craft'],
    /**
     * SMS tier — every SMS body and SMS-consent surface (invite SMS, public
     * consent page, portal consent copy). Keeps the carrier-registered entity
     * visible: the Twilio toll-free verification of +18449762530 was filed
     * under "97 Display" (approved 2026-08-21), so texts and the consent
     * language they point at stay traceable to that identity.
     */
    smsBrandName: 'LeadCraft by 97 Display',
    /** The registered company. A provenance fact, not a display default. */
    companyName: '97 Display',
    /** Unchanged by the rebrand — addresses and domains are infrastructure. */
    supportEmail: 'support@97display.com',
    /** Email From: display name — renders as `LeadCraft <noreply@…>`. */
    emailFromName: 'LeadCraft',
};
//# sourceMappingURL=brand.js.map